import { Zap, Sun, Home, Mountain } from "lucide-react";

const items = [
  { icon: Zap, title: "Certificação Energética A+", desc: "Desempenho térmico excelente em todas as tipologias, maior conforto em todas as estações e redução significativa no consumo de energia." },
  { icon: Sun, title: "Pré-Instalação Fotovoltaica", desc: "Preparado para receber painéis solares. Uma escolha pensada para famílias que valorizam a sustentabilidade e a autonomia energética." },
  { icon: Home, title: "Casa Inteligente", desc: "Pré-instalação para sistemas de domótica em portas, iluminação, janelas, ar condicionado e correio. Conforto e controlo total no seu lar." },
  { icon: Mountain, title: "Materiais de Excelência", desc: "Pedra natural, alumínio com corte térmico. Durabilidade, estética e responsabilidade ambiental." },
];

export default function Sustainability() {
  return (
    <section id="sustentabilidade" data-testid="sustainability-section" className="relative py-24 lg:py-36 bg-[#2B3B31] text-[#F9F9F6] overflow-hidden">
      <div className="absolute inset-0 grain" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-14 lg:mb-24">
          <div className="lg:col-span-7 reveal">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#F9F9F6]/60 mb-6">Compromisso com o Futuro</div>
            <h2 className="font-display text-[36px] sm:text-[44px] lg:text-[56px] leading-[1.05] tracking-[-0.02em] text-[#F9F9F6] text-balance">
              Arquitetura que
              <br />
              <span className="italic-display text-[#D9D6C5]">respira natureza.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 self-end reveal" style={{ transitionDelay: "120ms" }}>
            <p className="text-[15px] leading-relaxed text-[#F9F9F6]/75 font-light">
              Cada decisão construtiva orienta-se por um propósito: criar um edifício que envelhece bem, que cuida de quem o habita e que pesa menos sobre o ambiente.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#F9F9F6]/10 border border-[#F9F9F6]/10">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`sustain-${i}`}
                className="bg-[#2B3B31] p-8 lg:p-12 reveal"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon size={32} strokeWidth={1.1} className="text-[#D9D6C5]" />
                  <span className="text-[11px] tracking-[0.24em] uppercase text-[#F9F9F6]/45">0{i + 1}</span>
                </div>
                <h3 className="font-display text-2xl lg:text-3xl text-[#F9F9F6] mb-4 tracking-tight">{it.title}</h3>
                <p className="text-[14px] leading-relaxed text-[#F9F9F6]/70">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
